import { motion } from "framer-motion";
import { Reveal, GoldDivider } from "./Reveal";
import { PROCESS } from "../../data/site";
import { useLang } from "../../i18n/LanguageContext";

const Process = () => {
  const { t } = useLang();
  const steps = t.process.steps;
  return (
    <section id="process" data-testid="process-section" className="grain relative bg-forest py-24 md:py-32">
      <div className="relative z-10 mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal className="text-center">
          <p className="overline text-gold">{t.process.overline}</p>
          <h2 className="mt-2 font-serif font-light text-cream text-4xl md:text-5xl lg:text-6xl">
            {t.process.title}
          </h2>
          <GoldDivider dark />
          <p className="mx-auto mt-4 max-w-xl text-cream/70 leading-relaxed">
            {t.process.subtitle}
          </p>
        </Reveal>

        <div className="mt-20 flex flex-col gap-24 md:gap-32">
          {steps.map((step, i) => {
            const reversed = i % 2 === 1;
            return (
              <div
                key={i}
                data-testid={`process-step-${i}`}
                className={`grid grid-cols-1 items-center gap-10 md:grid-cols-2 md:gap-16 ${
                  reversed ? "md:[direction:rtl]" : ""
                }`}
              >
                <Reveal className="[direction:ltr]">
                  <div className="relative">
                    <span className="font-serif text-[7rem] leading-none text-gold/25 md:text-[9rem]">
                      {PROCESS[i].no}
                    </span>
                    <div className="-mt-8 md:-mt-12">
                      <h3 className="font-serif text-3xl text-cream md:text-4xl">{step.title}</h3>
                      <span className="mt-4 mb-5 block h-[1px] w-16 bg-gold" />
                      <p className="max-w-md text-cream/70 leading-relaxed">{step.text}</p>
                    </div>
                  </div>
                </Reveal>

                <div className="[direction:ltr]">
                  <motion.div
                    initial={{ opacity: 0, scale: 0.94 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                    className="spotlight overflow-hidden"
                  >
                    <img
                      src={PROCESS[i].image}
                      alt={step.title}
                      className="h-[340px] w-full object-cover md:h-[440px]"
                    />
                  </motion.div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Process;
